/* ══════════════════════════════════════
   TOPNAV / HEADER
   Matches Licensing Dashboard exactly
   ══════════════════════════════════════ */

.topnav {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 10px 32px;
  position: sticky;
  top: 0;
  z-index: 40;
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  border-bottom: 1px solid var(--glass-border);
}

/* ── Left: Back/Forward ── */
.left {
  display: flex;
  align-items: center;
  gap: 2px;
  /* grid col 1: left-aligned */
  justify-self: start;
}

.navBtn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 5px;
  transition: color 0.15s, background 0.15s;
  padding: 0;
  position: relative;
}

.navBtn:hover {
  color: var(--text-primary);
  background: var(--bg-hover);
}

/* ── Center: Search trigger (opens SpotlightSearch) ── */
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  /* grid col 2: auto-width, always perfectly centred in the viewport */
}

.searchTrigger {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 360px;
  max-width: 60vw;
  padding: var(--space-2) var(--space-3);
  background: var(--bg-elevated);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  color: var(--text-muted);
  cursor: pointer;
  font-family: inherit;
}

.searchTrigger:hover {
  border-color: var(--border-default);
}

.searchIcon {
  color: var(--text-muted);
  flex-shrink: 0;
}

.searchText {
  flex: 1;
  font-size: var(--text-sm);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kbd {
  font-size: var(--text-xs);
  color: var(--text-muted);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
  padding: 0 var(--space-1);
  flex-shrink: 0;
}

/* ── Right: Actions ── */
.right {
  display: flex;
  align-items: center;
  gap: 8px;
  /* grid col 3: right-aligned — expands freely without touching the centre */
  justify-self: end;
}

.iconBtn {
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  transition: color 0.15s, background 0.15s;
  padding: 0;
  position: relative;
}

.iconBtn:hover {
  color: var(--text-primary);
  background: var(--bg-hover);
}

.btn {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid var(--border-default);
  background: var(--bg-surface);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.btn:hover {
  color: var(--text-primary);
  border-color: var(--border-strong);
  background: var(--bg-hover);
}

/* Plexie AI orb button */
.btnAi {
  background: transparent;
  border-color: transparent;
  width: 42px;
  height: 42px;
  overflow: hidden;
}

.btnAi:hover {
  background: transparent;
  border-color: transparent;
}

.aiOrb {
  animation: orbSpin 12s linear infinite;
  transition: opacity 0.4s ease;
}

.aiOrbDefault {
  opacity: 1;
}

.aiOrbHover {
  position: absolute;
  inset: 0;
  margin: auto;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.btnAi:hover .aiOrbDefault {
  opacity: 0;
}

.btnAi:hover .aiOrbHover {
  opacity: 1;
}

@keyframes orbSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--bg-elevated);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid var(--border-default);
  transition: border-color 0.15s;
}

.avatar:hover {
  border-color: var(--text-muted);
}
